export async function loadSVG(url) {
	const res = await fetch(url);
	if (!res.ok) throw new Error(`Failed to load: ${res.status}`);
	return await res.text(); // SVG as string
}
